import type { ShopifyProduct } from 'types/product/ShopifyProduct';
import type { Subscription } from 'types/product/Subscription';

export const getSubscriptions = (
  shopifyProduct?: ShopifyProduct | null,
): Subscription[] => {
  if (!shopifyProduct) return [];

  return 'subscriptions' in shopifyProduct ? shopifyProduct.subscriptions : [];
};
